import React from "react";

import { Button } from "../../../../../common/button";

import { XMarkIcon } from "@heroicons/react/16/solid";

export function DialogTitleWithClose({title, onClose}) {
  return (
    <div class="text-lg flex flex-row justify-between">
      <div class="font-medium">{title}</div>
      <div class="text-lg">
        <Button plain onClick={onClose}>
          <XMarkIcon />
        </Button>
      </div>
    </div>
  );
}
